"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var Styling_1 = require("../../Styling");
exports.getStyles = Utilities_1.memoizeFunction(function (theme, customStyles) {
    var styles = {
        root: {
            width: '340px',
            pointerEvents: 'none',
            selectors: {
                '.ms-Callout': {
                    boxShadow: '0 0 20px rgba(0, 0, 0, .2)',
                    border: 'none',
                    selectors: (_a = {},
                        _a[Styling_1.HighContrastSelector] = {
                            border: '1px solid WindowText',
                        },
                        _a)
                }
            }
        },
        compactCard: {
            pointerEvents: 'auto',
            position: 'relative'
        },
        expandedCard: [
            {
                height: '1px',
                overflowY: 'hidden',
                pointerEvents: 'auto',
                transition: 'height 0.467s cubic-bezier(0.5, 0, 0, 1)',
                selectors: {
                    ':before': {
                        content: '""',
                        position: 'relative',
                        display: 'block',
                        top: '0',
                        left: '24px',
                        width: '292px',
                        height: '1px',
                        backgroundColor: theme.palette.neutralLighter
                    }
                }
            }
        ],
        expandedCardScroll: {
            height: '100%',
            boxSizing: 'border-box',
            overflowY: 'auto'
        }
    };
    return Styling_1.concatStyleSets(styles, customStyles);
    var _a;
});
//# sourceMappingURL=ExpandingCard.styles.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/HoverCard/ExpandingCard.styles.js
// module id = 1570
// module chunks = 0